(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["badewannen-atelier"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const load=()=>document.querySelectorAll('obermaier-badewannen[data-module]:not([data-started])').forEach(host=>{
  host.dataset.started='true';
  import(host.dataset.module).catch(()=>{const status=host.querySelector('[role="status"]');if(status){status.textContent='Die 3D-Ansicht konnte nicht geladen werden. Bitte laden Sie die Seite erneut oder kontaktieren Sie uns für Ihre Konfiguration.';status.setAttribute('role','alert');}});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load,{once:true});else load();
 document.addEventListener('shopify:section:load',load);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-bathtub-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-luxury-bathtub-story]');
    if (!sections.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

      sections.forEach((section) => {
        section.querySelectorAll('.luxury-bathtub__reveal').forEach((item) => observer.observe(item));
      });
    } else {
      sections.forEach((section) => {
        section.querySelectorAll('.luxury-bathtub__reveal').forEach((item) => item.classList.add('is-visible'));
      });
    }

    if (reduceMotion) return;

    let ticking = false;
    const updateParallax = () => {
      sections.forEach((section) => {
        const hero = section.querySelector('[data-luxury-hero]');
        const media = section.querySelector('[data-luxury-parallax]');
        if (!hero || !media) return;

        const rect = hero.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height)));
        const offset = (progress - 0.5) * 44;
        media.style.setProperty('--luxury-parallax', `${offset}px`);
      });
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maritim-atelier"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const loadAteliers=()=>document.querySelectorAll('obermaier-maritim[data-module]:not([data-observed])').forEach(host=>{
      host.dataset.observed='true';
      const observer=new IntersectionObserver(entries=>{
        if(!entries.some(entry=>entry.isIntersecting))return;
        observer.disconnect();
        import(host.dataset.module).catch(()=>{
          const message=host.querySelector('[role="status"]');
          if(message){message.textContent=host.dataset.fallback;message.setAttribute('role','alert');}
        });
      },{rootMargin:'400px'});
      observer.observe(host);
    });
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',loadAteliers,{once:true});else loadAteliers();
    document.addEventListener('shopify:section:load',loadAteliers);
  })();

  } catch(e) { console.error(e); }
})();
})();
